var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('edit-creative', _vm._g({ attrs: { "action": "copy", "createRequest": _vm.createRequest, "type": _vm.type, "id": _vm.id, "dialog": { title: _vm.innerText } } }, _vm.$listeners), [_vm._v(_vm._s(_vm.innerText))]);
};
var staticRenderFns = [];

export { render, staticRenderFns };